'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * Factory function for initiating chain.
 * @param   {object} state Optional. Sets the initial state object passed between steps.
 * @return  {object} Chain Chain instance.
*/
var Chains = exports.Chains = function Chains(state) {
    // Validate input
    if (!isValidStateObject(state)) {
        throw new Error('Initial argument must be an object if specified');
    }

    // Create internal objects
    var _state = Object.assign({}, state || {});
    var _promise = Promise.resolve();

    // Create chain instance
    var instance = {
        then: function then(func) {
            return _then(func);
        },
        catch: function _catch(func) {
            return _catch2(func);
        }
    };

    // Then method
    var _then = function _then(func) {
        // The generator
        _promise = _promise.then(function () {
            return new Promise(function (resolve, reject) {
                func(_state, function (err) {
                    if (err) {
                        reject(err);
                    }

                    resolve();
                });
            });
        });

        return instance;
    };

    // Catch method
    var _catch2 = function _catch2(func) {
        _promise = _promise.catch(function (error) {
            func(error, _state);
        });
    };

    // return instance
    return instance;
};

/**
 * Check whether argument is either an object, null, or undefined.
 * @param   {object} state  Input to check.
 * @return  {bool}   result True, or false.
*/
var isValidStateObject = function isValidStateObject(state) {
    var valid_input = ['[object Object]', '[object Undefined]', '[object Null]'];

    return valid_input.indexOf(Object.prototype.toString.call(state)) !== -1;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/c4s/dist/chains.js
// module id = 7sA0
// module chunks = 0